"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMiddleware = useMiddleware;
function useMiddleware(...middleware) {
  return middleware.reduce((current, acc) => args => current(acc(args)));
}
